<template lang="pug">
  app-modal(
    :titulo="titulo",
    :width="width"
    @closeModal="closeModal()"
  )
    template(slot="body")
      el-row
        el-table.texto(
          ref="tabelaProcessos"
          :data="tipos"
          @selection-change="handleSelection"
          )
          el-table-column(type="selection", width="55")
          el-table-column(property="nome")
    template(slot="footer")
      .flex
        el-button.btn.texto(
          type="default",
          size="small",
          @click="closeModal()"
        )
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn.texto(
          type="success",
          size="small",
          @click="save()"
        )
          span.center
            b &nbsp Confirmar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppModal from '@/components/AppModal'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {

  components: {
    AppModal
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    width: {
      type: Number,
      default: 900
    },
    tipos: {
      type: Array,
      required: true
    },
    usuario: {
      required: true
    }
  },

  mounted () {
    this.initTiposProcesso()
  },

  data () {
    return {
      tiposSelecionados: [],
      perfil: ''
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),
    titulo () {
      return `Vincular processos para ${this.usuario.nome}`
    }
  },

  methods: {
    ...mapActions({
      saveVinculosUsuario: 'vinculoDistribuicaoProcesso/saveVinculosUsuario',
      saveVinculosPerfil: 'vinculoDistribuicaoProcesso/saveVinculosPerfil'
    }),

    closeModal () {
      this.$emit('closeModal')
    },

    save () {
      if (this.funcao()) {
        this.saveVinculosUsuario({vinculos: this.tiposSelecionados, id: this.usuario.id, codigo: this.usuarioLogado.perfilSelecionado.setor.codigo}).then((data) => {
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, data)
          this.closeModal()
        }).catch((message) => {
          this.showNotificacao(this.$$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, message)
          this.closeModal()
        })
      } else {
        this.saveVinculosPerfil({vinculos: this.tiposSelecionados, id: this.usuario.id, codigo: this.usuarioLogado.perfilSelecionado.setor.codigo}).then((data) => {
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, data)
          this.closeModal()
        }).catch((message) => {
          this.showNotificacao(this.$$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, message)
          this.closeModal()
        })
      }
    },

    funcao () {
      return !!this.usuario.pessoa
    },

    handleSelection (tiposSelecionados) {
      this.tiposSelecionados = tiposSelecionados
    },

    initTiposProcesso () {
      const tipoVinculados = this.usuario.vinculos.map(vinculo => vinculo.tipoCadastro.codigo)
      this.tipos.filter((tipo) => tipoVinculados.indexOf(tipo.codigo) > -1)
        .forEach(tipo => this.$refs.tabelaProcessos.toggleRowSelection(tipo, true))
    }
  }
}

</script>

<style scoped lang="scss">

p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
margin-top: 5px;
display: flex;
justify-content: space-between;
}

.texto {
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalSelecionarTipoProcesso.vue